module.exports = __webpack_public_path__ + "static/media/Studentssample.84a49fc5.xls";